export default {
    title: "Eventos Personalizados",
    empty_message: "Você ainda não possui nenhum Evento,",
    empty_action: "crie o primeiro agora!",
    new_event_button: "Novo Evento",
    search_placeholder: "Buscar eventos...",
    no_results_found: 'Nenhum evento encontrado para "<strong>{0}</strong>".',
    clear_search: "Limpar busca",
    save_success: "Salvo com sucesso",
    save_button: "Salvar",
    page_title: "Kevi | Eventos Personalizados",
    event_title_label: "Título do Evento",
    event_title_placeholder: "Título do Evento",
    cannot_edit_warning:
        "Esse evento possui uma ou mais ocorrências registradas no sistema e não pode ser removido ou ter seu título alterado.",
    registrations_count: "{0} ocorrência do evento registrada",
    registrations_count_plural: "{0} ocorrências do evento registradas",
    archive_event: "Arquivar evento",
    remove_notice: 'O Evento "{0}" será removido ao salvar.',
    undo: "Desfazer",
    register_event_button: "Registrar Evento",
    register_event_title: "Registrar Evento",
    search_event_placeholder: "Buscar evento...",
    no_events_created: "Nenhum evento personalizado criado no momento",
    create_event_button: "Criar Evento",
    register_confirmation_title: "Deseja registrar o evento?",
    register_confirmation_body:
        'Essa ação é irreversível e irá adicionar o evento personalizado <strong>"{0}"</strong> à linha de tempo desse cliente.',
    register_success: "Evento personalizado registrado com sucesso!",
    register_error: "Erro ao registrar evento personalizado.",
};
